export const Content = ({ children }: { children: React.ReactNode }) => (
  <div style={{ padding: 'var(--padding-200)' }}>{children}</div>
);
